const CirculoRojo = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 -1.51594e-06 15.5228 8.74228e-07 10C1.35705e-06 4.47715 4.47715 -1.35705e-06 10 -8.74228e-07C15.5228 1.51594e-06 20 4.47715 20 10ZM10.0011 14.4434C10.6147 14.4434 11.1122 14.9408 11.1122 15.5545C11.1122 16.1681 10.6147 16.6656 10.0011 16.6656C9.38744 16.6656 8.88997 16.1681 8.88997 15.5545C8.88997 14.9408 9.38744 14.4434 10.0011 14.4434ZM11.1122 4.44444C11.1122 3.83079 10.6147 3.33333 10.0011 3.33333C9.38744 3.33333 8.88998 3.83079 8.88998 4.44444L8.88997 11.1111C8.88997 11.7248 9.38743 12.2222 10.0011 12.2222C10.6147 12.2222 11.1122 11.7248 11.1122 11.1111L11.1122 4.44444Z"
        fill="#C10C00"
      />
    </svg>
  );
};

export default CirculoRojo;
